import { useEffect } from 'react';
import { useAuth } from '../../components/features/auth/AuthGuard';
import AppraisalList from '../../components/features/performance/AppraisalList';
import { PERMISSIONS } from '../../constants';
import { Box, Alert } from '@mui/material';

const MyAppraisalsPage = () => {
  const { hasPermission } = useAuth();

  // Check if user has permission to view appraisals
  if (!hasPermission(PERMISSIONS.PERFORMANCE_READ)) {
    return (
      <Box p={3}>
        <Alert severity="error">
          You don't have permission to view performance appraisals.
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <AppraisalList 
        type="my"
        title="My Performance Appraisals"
      />
    </Box>
  );
};

export default MyAppraisalsPage;
